<section class="banner-style-one">
  <div class="parallax"
       style="background-image: url(/assets/images/about.png);"></div>

  <div class="breadcrums">
    <div class="container">
      <div class="row">
        <ul>
          <li>
            <a [routerLink]="['/']">
              <i class="fa-solid fa-house"></i>
              <p>Inicio</p>
            </a>
          </li>
          <li class="current">
            <p>Nosotros</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="gap about-first">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="who-we-are">
          <h2>Bienvenidos a Tiger Zen Do</h2>
          <p>Más de 30 años formando personas a través de las artes marciales.</p>
          <figure>
            <img class="w-1000"
                 [height]="600"
                 src="/assets/images/about.png"
                 alt="About Image One">
          </figure>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="who-we-are space">
          <div>
            <h3>¿QUIENES SOMOS?</h3>
            <p>Somos el <b>primer</b> centro de artes marciales de Trujillo.
              Desde 1991, nos hemos dedicado a brindar la <b>enseñanza
                tradicional y deportiva</b> de las artes marciales de Tae
              Kwon Do y Muay Thai, así como cursos de defensa
              personal, MMA y Combat Sambo. Nuestra experiencia
              nos ha permitido enseñar tanto a civiles como a
              <b>personal militar y seguridad ciudadana</b>.
            </p>
          </div>
          <div>
            <h2>¿Qué nos hace únicos?</h2>
            <ul>
              <li><i class="fa-solid fa-circle-dot"></i> Entrenadores certificados con más de 30 años de experiencia.
              </li>
              <li><i class="fa-solid fa-circle-dot"></i> Programas para mejorar tu fuerza, disciplina y confianza.</li>
              <li><i class="fa-solid fa-circle-dot"></i> Clases grupales e individuales adaptadas a tus objetivos.</li>
              <li><i class="fa-solid fa-circle-dot"></i> Enfoque en valores y crecimiento personal.</li>
              <li><i class="fa-solid fa-circle-dot"></i> Infraestructura moderna y tecnología avanzada.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
